import { render, staticRenderFns } from "./compClubConfig.vue?vue&type=template&id=6efd4ec7&scoped=true&"
import script from "./compClubConfig.vue?vue&type=script&lang=js&"
export * from "./compClubConfig.vue?vue&type=script&lang=js&"
import style0 from "./compClubConfig.vue?vue&type=style&index=0&id=6efd4ec7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efd4ec7",
  null
  
)

export default component.exports